// Api.
import api from '../Base';

// Types.
import HostTarget from '../../types/host/HostTarget'; // Keep existing if used elsewhere
import HostInstances from "../../types/host/HostInstances"; // Keep existing if used elsewhere
import HostStatistic from '../../types/host/HostStatistic';
import HostTimeStatistic from '../../types/host/HostTimeStatistic';
import { showError } from '../../utils/showAlert';

// Placeholder type for datasource-host mapping
export interface DatasourceHostMap {
    id: number; // Corrected field name from datasource_id
    hostid: number; // Renamed from host_id to match log output
    // Add other relevant fields if known
}

// Removed HostDetail interface

const HostApi = {

    getHosts:async (): Promise<HostTarget[]> => { // Revert return type to HostTarget[]

        let url = `host?sort=2+asc`;

        let hosts: HostTarget[] = []; // Revert type

        await api.get<HostTarget[]>(url) // Revert type
            .then((response) => {
                hosts = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve hosts.', error);
                showError('Failed to retrieve hosts', error.message || error.toString());
            });

        return hosts;
    },

    // Add the new function here
    getDatasourceHostMapping: async (): Promise<DatasourceHostMap[]> => {
        const url = `datasource/host`;
        let mapping: DatasourceHostMap[] = [];

        await api.get<DatasourceHostMap[]>(url)
            .then((response) => {
                mapping = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve datasource-host mapping.', error);
                showError('Failed to retrieve datasource-host mapping', error.message || error.toString());
                // Optionally re-throw or return empty array based on desired error handling
            });

        return mapping;
    },


    getHostTypes:async () => {

        let url = `host/type?collect=true`;

        let hosts: any[] = [];

        await api.get<any[]>(url)
            .then((response) => {
                hosts = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve hosts.', error);
                showError('Failed to retrieve hosts', error.message || error.toString());
            });

        return hosts;
    },

    getHostStatisticTypes:async () => {

        let url = `host/statistic/type?collect=true`;

        let types: any[] = [];

        await api.get<any[]>(url)
            .then((response) => {
                types = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve instances.', error);
                showError('Failed to retrieve instances', error.message || error.toString());
            });

        return types;
    },

    
    getHost:(hostId: number) => {

        let url = `host?sort=2+asc&id=${hostId}`;

        api.get<HostTarget[]>(url)
            .then((response) => {
                return response.data[0];
            })
            .catch((error: any) => {
                console.error('Failed to retrieve host.', error);
                showError('Failed to retrieve host', error.message || error.toString());
            });
    },

    getHostInstances:async (id: number) => {

        let url = `datasource/host?hostid=${id}`;

        let instances: HostInstances[] = [];

        await api.get<HostInstances[]>(url)
            .then((response) => {
                instances = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve hosts.', error);
                showError('Failed to retrieve hosts', error.message || error.toString());
            });

        return instances;
    },

    getHostStatisticSummary: async (
        timeRangeQueryString: string,
        statistic: string,
        hostId?: number
    ): Promise<HostStatistic[]> => {
        const idParam = hostId !== undefined ? `&id=${hostId}` : '';
        const url = `host/statistic/summary?${timeRangeQueryString}&statistic=${encodeURIComponent(statistic)}${idParam}`;
        let data: HostStatistic[] = [];

        await api.get<HostStatistic[]>(url)
            .then((response) => {
                data = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve host statistic summary.', error);
                showError('Failed to retrieve host statistic summary', error.message || error.toString());
            });

        return data;
    },

    getHostStatisticTime: async (
        timeRangeQueryString: string,
        hostId: number,
        statistic: string,
        limit?: number
    ): Promise<HostTimeStatistic[]> => {
        const limitParam = limit !== undefined ? `&limit=${limit}` : '';
        const url = `host/statistic/time?${timeRangeQueryString}&statistic=${encodeURIComponent(statistic)}&id=${hostId}${limitParam}`;
        let data: HostTimeStatistic[] = [];

        await api.get<HostTimeStatistic[]>(url)
            .then((response) => {
                data = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve host statistic time.', error);
                showError('Failed to retrieve host statistic time', error.message || error.toString());
            });

        return data;
    },
}

export default HostApi;
